import React from 'react';
import ReactDOM from 'react-dom';
import './main.scss';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import bootstrap from 'bootstrap';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';
import { appConfig } from './Config/app';

import loginApiReducer from './Redux/reducers/login';
import signupApiReducer from './Redux/reducers/signup';
import projectApiReducer from './Redux/reducers/project';
import sidebarReducer from './Redux/reducers/sidebar';

import loginRootSaga from './Redux/sagas/login';
import signupRootSaga from './Redux/sagas/signup';
import userInformationApiReducer from './Redux/reducers/user_information';
import userInformationRootSaga from './Redux/sagas/user_information';
import projectRootSaga from './Redux/sagas/project';
import shootApiReducer from './Redux/reducers/shoot';
import shootRootSaga from './Redux/sagas/shoot';
import inviteApiReducer from './Redux/reducers/invite';
import inviteRootSaga from './Redux/sagas/invite';
import gearApiReducer from './Redux/reducers/gear';
import gearRootSaga from './Redux/sagas/gear';
import tutorialReducer from 'Redux/reducers/tutorial';
import onboardingRootSaga from 'Redux/sagas/onboarding';
import onboardingReducer from 'Redux/reducers/onboarding';
import teamApiReducer from 'Redux/reducers/team';
import teamRootSaga from 'Redux/sagas/team';
import paymentApiReducer from 'Redux/reducers/payment';
import paymentRootSaga from 'Redux/sagas/payment';
import channelRootSaga from 'Redux/sagas/channel';
import organizationRootSaga from 'Redux/sagas/organization';
import channelApiReducer from 'Redux/reducers/channel';
import { auth } from 'Utils/auth';

const sagaMiddleware = createSagaMiddleware();

// The token lives in Utils/auth.js only; persisting it here too caused the copies to drift.
const authPersistConfig = {
  key: 'auth',
  storage: storage,
  whitelist: ['user', 'user_information'],
};

const sidebarPersistConfig = {
  key: 'sidebar',
  storage: storage,
  whitelist: ['selectedProject'],
};

// Persist only the selected org (a hint); reconciled against the server list on load.
const userInformationPersistConfig = {
  key: 'userInformation',
  storage: storage,
  whitelist: ['selectedOrganisation'],
};

const store = createStore(
  combineReducers({
    auth: persistReducer(authPersistConfig, loginApiReducer),
    signup: signupApiReducer,
    project: projectApiReducer,
    shoot: shootApiReducer,
    sidebar: persistReducer(sidebarPersistConfig, sidebarReducer),
    userInformation: persistReducer(
      userInformationPersistConfig,
      userInformationApiReducer,
    ),
    invite: inviteApiReducer,
    gear: gearApiReducer,
    tutorial: tutorialReducer,
    onboarding: onboardingReducer,
    team: teamApiReducer,
    payment: paymentApiReducer,
    channel: channelApiReducer,
  }),
  composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

let persistor = persistStore(store);

auth.watchLogoutInOtherTabs();

sagaMiddleware.run(loginRootSaga);
sagaMiddleware.run(signupRootSaga);
sagaMiddleware.run(userInformationRootSaga);
sagaMiddleware.run(projectRootSaga);
sagaMiddleware.run(shootRootSaga);
sagaMiddleware.run(inviteRootSaga);
sagaMiddleware.run(gearRootSaga);
sagaMiddleware.run(onboardingRootSaga);
sagaMiddleware.run(teamRootSaga);
sagaMiddleware.run(paymentRootSaga);
sagaMiddleware.run(channelRootSaga);
sagaMiddleware.run(organizationRootSaga);

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={appConfig.GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
